import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagementDashboardRoutingModule } from './management-dashboard-routing.module';
import { ManagementDashboardComponent } from './management-dashboard.component';
import { HeadquarterModule } from '../headquarter.module';
import { MangmntDashComponent } from './mangmnt-dash/mangmnt-dash.component';
import { ManagementLoginComponent } from './management-login/management-login.component';


@NgModule({
  declarations: [
    ManagementDashboardComponent,
    MangmntDashComponent,
    ManagementLoginComponent
  ],
  imports: [
    CommonModule,
    ManagementDashboardRoutingModule,
    HeadquarterModule
  ]
})
export class ManagementDashboardModule { }
